import React from 'react';
import { formatPhone } from '@search/helpers/src/formatPhone';
import { graphql, useGqlContext } from '@search/gql-client/src';

import type {
    useRepairRequestMutation$data,
    useRepairRequestMutation$variables
} from './__generated__/useRepairRequestMutation.graphql';

const mutation = graphql`
    mutation useRepairRequestMutation($phone: String!, $url: String, $totalPrice: String) {
        sendRepairContactForm(phone: $phone, url: $url, totalPrice: $totalPrice) {
            errorText
        }
    }
`;

export const useRepairRequest = () => {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: useRepairRequestMutation$variables, opts?: { signal?: AbortSignal }) => gql.client<
            useRepairRequestMutation$variables,
            useRepairRequestMutation$data>(
                mutation,
                {
                    ...vars,
                    phone: formatPhone(vars.phone)
                },
                opts
            ),
        [ gql ]
    );
};
